import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'capacity-planning.field-1-name': {
    id: 'capacity-planning.field-1-name',
    defaultMessage: 'Team member',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Team member'
  },
  'capacity-planning.field-2-name': {
    id: 'capacity-planning.field-2-name',
    defaultMessage: 'Role',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Role'
  },
  'capacity-planning.field-2-select-option-1': {
    id: 'capacity-planning.field-2-select-option-1',
    defaultMessage: 'Designer',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Designer'
  },
  'capacity-planning.field-2-select-option-2': {
    id: 'capacity-planning.field-2-select-option-2',
    defaultMessage: 'Engineer',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Engineer'
  },
  'capacity-planning.field-2-select-option-3': {
    id: 'capacity-planning.field-2-select-option-3',
    defaultMessage: 'Human Resources',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Human Resources'
  },
  'capacity-planning.field-2-select-option-4': {
    id: 'capacity-planning.field-2-select-option-4',
    defaultMessage: 'Marketing Manager',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Marketing Manager'
  },
  'capacity-planning.field-2-select-option-5': {
    id: 'capacity-planning.field-2-select-option-5',
    defaultMessage: 'Product Manager',
    description:
      'The option value for option #5 in field #2 for this database template. In this case: Product Manager'
  },
  'capacity-planning.field-3-name': {
    id: 'capacity-planning.field-3-name',
    defaultMessage: 'Project',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Project'
  },
  'capacity-planning.field-3-select-option-1': {
    id: 'capacity-planning.field-3-select-option-1',
    defaultMessage: 'Analytics',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: Analytics'
  },
  'capacity-planning.field-3-select-option-2': {
    id: 'capacity-planning.field-3-select-option-2',
    defaultMessage: 'Dark mode',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: Dark mode'
  },
  'capacity-planning.field-3-select-option-3': {
    id: 'capacity-planning.field-3-select-option-3',
    defaultMessage: 'Messaging',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: Messaging'
  },
  'capacity-planning.field-3-select-option-4': {
    id: 'capacity-planning.field-3-select-option-4',
    defaultMessage: 'Notifications',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: Notifications'
  },
  'capacity-planning.field-3-select-option-5': {
    id: 'capacity-planning.field-3-select-option-5',
    defaultMessage: 'Reports',
    description:
      'The option value for option #5 in field #3 for this database template. In this case: Reports'
  },
  'capacity-planning.field-4-name': {
    id: 'capacity-planning.field-4-name',
    defaultMessage: 'Available capacity (days)',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Available capacity (days)'
  },
  'capacity-planning.field-5-name': {
    id: 'capacity-planning.field-5-name',
    defaultMessage: 'PTO (days)',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: PTO (days)'
  },
  'capacity-planning.field-6-name': {
    id: 'capacity-planning.field-6-name',
    defaultMessage: 'Jira work items',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Jira work items'
  },
  'capacity-planning.view-1-name': {
    id: 'capacity-planning.view-1-name',
    defaultMessage: 'All capacity',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All capacity'
  }
});
